import React, { useState, useEffect } from 'react';

import ReactPaginate from 'react-paginate';
import $ from 'jquery';

import { FaTag } from 'react-icons/fa';
import Tag from '../Tag';
import { ClearTag, ROUTES } from '../../assets/constants/strings';
import SortButton from '../Buttons/SortButton';
import { Link } from 'react-router-dom';
import TabIndexBtn from '../Buttons/TabIndex';
import { connect } from 'react-redux';
import { setCurrentDocument } from '../../store/Document/documentActions';

const DocumentResults = ({
  handleOnTagSelected,
  pagesFoundInDocument,
  isSearchPage,
  setCurrentDocument
}) => {
  const [selectedPage, setSelectedPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const [selectedOrder, setSelectedOrder] = useState('>');

  const handleTagSelected = (tag) => {
    handleOnTagSelected(tag);
  };

  $('[data-toggle="tooltip"]').tooltip();

  useEffect(() => {
    $('[data-toggle="tooltip"]').tooltip();
    setSelectedPage(1);
  }, [pagesFoundInDocument]);

  const pagesCount = Math.ceil(pagesFoundInDocument.length / itemsPerPage);
  const indexOfLastItem = selectedPage * itemsPerPage;
  const indexOfFirstTodo = indexOfLastItem - itemsPerPage;
  const currentPages =
    selectedOrder === '>'
      ? pagesFoundInDocument
        .sort((a, b) => a.title.localeCompare(b.title, undefined, { numeric: true }))
        .slice(indexOfFirstTodo, indexOfLastItem)
      : pagesFoundInDocument
        .sort((a, b) => b.title.localeCompare(a.title, undefined, { numeric: true }))
        .slice(indexOfFirstTodo, indexOfLastItem);

  const handlePaginationClick = (selectedItem) => {
    setSelectedPage(selectedItem.selected + 1);
  };

  const handleOrder = () => {
    const currOrder = selectedOrder;
    currOrder === '>' ? setSelectedOrder('<') : setSelectedOrder('>');
  };

  return (
    <div>
      <div className="main-content-wrapper search-results">
        <div className="row d-flex justify-content-end mx-0">
          <SortButton sort={selectedOrder} handleOrder={handleOrder} />
        </div>
        {currentPages.map((page) => (
          <div className="wf-main-content" key={page.id}>
            {isSearchPage ? (
              <Link
                onClick={() => setCurrentDocument(page.documentSlug, page.slug)}
                className="h4 font-weight-bold search-item-title"
                to={ROUTES.DOCUMENT(page.documentSlug, page.slug)}
                title={page.documentName + ' | ' + page.title}
              >
                {page.title}
              </Link>
            ) : (
              <a
                className="h4 font-weight-bold search-item-title"
                href={ROUTES.DOCUMENT(page.documentSlug, page.slug)}
                target="_blank"
                rel="noreferrer"
                title={page.documentName + ' | ' + page.title}
              >
                {page.title}
              </a>
            )}
            <div
              className="wf-main-content mt-3"
              dangerouslySetInnerHTML={{
                __html: page.HTMLContent.substring(0, 800) + ' ...',
              }}
            />

            <div className="wf-tags wf-border-b d-flex mb-4 py-3">
              <div className="mr-2">
                <FaTag className="mr-2" fontSize="1.45rem" />
              </div>
              <div className="d-flex flex-wrap">
                {page.tags && page.tags.split(',')
                  .map((tag, i) => {
                    if (tag.match('CUSTOMTAG')) {
                      // custom tag
                      return (
                        <TabIndexBtn key={tag.trim()} handleClick={() => handleTagSelected(ClearTag(tag))}>
                          <div className="tag badge px-2 py-1 m-1 custom-tag">
                            <span>{ClearTag(tag)}</span>
                          </div>
                        </TabIndexBtn>
                      );
                    } else if (
                      !(
                        tag.trim().length <= 2 || // has two characters
                        tag.match(/[^0-9a-z!\s]/gi) || // has non alphanumeric chars
                        (tag.match(/\d/g) && tag.match(/\d/g).length > 1)
                      ) // has more than one number
                    ) {
                      return <Tag text={tag.trim()} handleSelected={handleTagSelected} key={i} />;
                    } else return null;
                  })}
              </div>
            </div>
          </div>
        ))}
        {pagesCount > 1 && (
          <div className="text-center pagination-wrapper">
            <ReactPaginate
              onPageChange={handlePaginationClick}
              previousLabel={'previous'}
              previousClassName={'paginate-previous'}
              nextLabel={'next'}
              nextClassName={'paginate-next'}
              breakLabel={'...'}
              breakClassName={'page-item'}
              breakLinkClassName={'page-link'}
              pageCount={pagesCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={10}
              containerClassName={'pagination pagination-sm'}
              pageClassName={'page-item'}
              pageLinkClassName={'page-link'}
              activeClassName={'page-item active'}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const mapDispatchToProps = { setCurrentDocument };

export default connect(null, mapDispatchToProps)(DocumentResults);
